<div class="my-container" [hidden]="!loading"><mat-progress-bar mode="indeterminate"></mat-progress-bar></div>
<div class='alert alert-danger malert-danger' *ngIf="err_validation">{{ err }}</div>
<div class='alert alert-danger malert-danger' *ngIf="err_internet_validation">{{ err_internet_text }} <span><i class="fas fa-sync icon" ></i></span></div>

<div mat-dialog-title class="matDialogTitle">
  <span>   فاکتور {{ factor }} </span>
  <span class="close" (click)="close()" ><mat-icon>close</mat-icon></span>
</div>

<div mat-dialog-content class="matDialogContent"> 
  <div class="row">
    <div class="container" style="width:100%"> 
      <div class="row file"> 
        <div class="col-md-12 col-lg-12 col-sm-12 col-xs-12 pe1" > 
        <form [dropzone]="config"  class="dropzone dz-started" id="my-awesome-dropzone" style="height:450px">
          <input type="" name="code" value="{{ factor }}" style="display:none">
          <input type="" name="username" value="{{ username }}" style="display:none">
          <input type="" name="type" value="{{ 2 }}" style="display:none">
      
          <div class="dz-preview dz-processing dz-image-preview dz-success dz-complete box box-right" *ngFor="let file of list_load_file" >  
            <div class="dz-image" style="border:solid 1px #ccc">
            <a href='{{ file.sales_attach_site }}/{{ file.sales_attach_name }}' target="_blank">
              <span *ngIf="file.sales_attach_type == 'image/jpeg' || file.sales_attach_type == 'image/gif' ||  file.sales_attach_type == 'image/png' ">
              <img data-dz-thumbnail="" alt="{{ file.sales_attach_title }}" src="{{ file.sales_attach_site }}/{{ file.sales_attach_name }}">
              </span>
              <span *ngIf="file.sales_attach_type == 'application/msword' || file.sales_attach_type == 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' ">
                <i class="far fa-file-word icone"></i> 
              </span>
              <span *ngIf="file.sales_attach_type == 'application/vnd.ms-excel' || file.sales_attach_type == 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ">
                <i class="fas fa-file-excel icone" style='color:green'></i> 
              </span> 
              <span *ngIf="file.sales_attach_type == 'application/pdf' ">
                <i class="far fa-file-pdf icone" style='color:red'></i> 
              </span>
              <span *ngIf="file.sales_attach_type == 'application/zip' ">
                <i class="fas fa-file-archive icone"></i> 
              </span>
              <span *ngIf="file.sales_attach_type == 'video/mp4' || file.sales_attach_type == 'video/x-matroska';else other ">
                <i class="fas fa-file-video icone" style='color:black'></i> 
              </span>
              <ng-template #other>
              <i class="fas fa-file-alt icone" style='color:black'></i>    
              </ng-template>
            </a>
            </div><!-- dz-image -->
            <div class="dz-details"> 
              <div style="display:inline;float:left">
                <span (click)="delete_file(file.sales_attach_id)" *ngIf="file.sales_attach_request_status == request_status_number"><i class="fas fa-trash-alt icon"></i></span>
              </div>   
            <div class="dz-size">
              <span data-dz-size=""><strong>{{ file.sales_attach_size }}</strong> KB</span>
            </div><!-- dz-size-->      
            <div class="dz-filename">
              <span data-dz-name="" class="pe1">{{ file.sales_attach_title }}</span>
            </div><!-- dz-filename-->  
            </div>  <!-- dz-detaile-->  
            <div class="dz-progress">
            <span class="dz-upload" data-dz-uploadprogress="" style="width: 100%;"></span>
            </div><!-- dz-progress -->   
            <div class="dz-error-message">
            <span data-dz-errormessage=""></span>
            </div><!-- dz-error-message -->    
          </div><!-- dz-preview dz-processing dz-image-preview dz-success dz-complete -->
        </form><!-- dropzone dz-started -->
        </div><!-- col-md-12 -->
        <div style="font-size: 11px;font-family: irsans;padding-left: 16px;padding-top: 11px;">
          Files : To upload your file, either click on the box below or drag your file down to the box Click on the other icons to activate other settings.
          <span (click)="load_file()"><i  class="fas fa-cogs icon"></i></span>
        </div>
      </div><!-- row file -->
    </div>
    </div>
</div><!-- content -->

<div mat-dialog-actions align="end" class="pe1"  style="padding-right:25px">

</div>